import { useRouter } from 'next/router';
import { useLocation } from 'react-router-dom';
import settings from './settings';

export default function useLocationPath(): string {
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
    const locationSearch = settings.isNextJS()
        ? /* eslint-disable-next-line react-hooks/rules-of-hooks */
          useRouter().pathname
        : /* eslint-disable-next-line react-hooks/rules-of-hooks */
          useLocation().search;

    return locationSearch;
}
